import { render, staticRenderFns } from "./PlantPartsData.vue?vue&type=template&id=5a8adb0c&"
import script from "./PlantPartsData.vue?vue&type=script&lang=ts&"
export * from "./PlantPartsData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports